import React from 'react'
import styled from 'styled-components'
import isFunction from 'lodash/isFunction'
import { LKButton } from 'loankeeper-common/components'

import LKModal from './LKModal'
import LKModalContainer from './container'
import { useLKModal } from './LKModalContext'

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`

const OkayButton = ({ onClick }) => {
  const { onClose } = useLKModal()

  const handleClick = React.useCallback(() => {
    onClose()

    if (isFunction(onClick)) {
      onClick()
    }
  }, [onClick, onClose])

  return (
    <LKButton alias="ok" className="okay-button" onClick={handleClick}>
      OK
    </LKButton>
  )
}

const LKDobModal = ({ modalInstanceName, message, onConfirm, params }) => (
  <LKModal
    name={modalInstanceName}
    heading="Info"
    size="xs"
    dataAttributes={params && { 'data-code': params.code }}
    footer={
      <LKModal.Footer>
        <OkayButton onClick={onConfirm} />
      </LKModal.Footer>
    }
  >
    <Wrapper>{message}</Wrapper>
  </LKModal>
)

export default LKModalContainer()(LKDobModal)
